import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"

import RegulaminFilePromo1 from "../../static/Regulamin-promocji-luty-2025-en.pdf"

import RegulaminFile from "../../static/ENG_ORLEN_TERMS_AND_CONDITIONS_INDIVIDUAL_CUSTOMER_VALID_FROM_12092024.pdf"
import RegulaminFileFlota from "../../static/ENG_ORLEN_TERMS_AND_CONDITIONS_ORLEN_FLEET_CUSTOMER_VALID_FROM_12092024.pdf"

import RegulaminFileOld from "../../static/general-terms-and-conditions-of-charging-services-PKN-ORLEN-2024.pdf"
import RegulaminFileFlotaOld from "../../static/general-terms-and-conditions-of-charging-services-PKN-ORLEN-flota-2024.pdf"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "regulamin-bg.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Regulamin = () => {
  const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | CHARGING TERMS AND CONDITIONS" />
      <Sublinks />
      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-regulamin`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
        <div className="bg-overlay"></div>
        <div
          className="visual-content col-md-8 ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <h1 className="font-xxl text-center font-bold">
            PROMOTION RULES "Winter Break with ORLEN Charge – Charging for 25% less"
          </h1>
          <p className="font-md font-light">Click to download the promotion rules in PDF format:</p>
          <div className="text-center">
          <a
              href={RegulaminFilePromo1}
              target="_blank" rel="noreferrer"
              className="d-inline-flex flex-column mx-2 mx-xl-4 align-items-center"
            >
            <div className="btn-download-sm">
              <span className="icon-pdf"></span>
            </div>
            <span className="btn-desc">Individual Customer / ORLEN fleet</span>
            </a>
          </div>
          <p className="text-center font-xs font-light mt-2 mb-4">Promotion rules are valid in the period from 1st until 28th of February, 2025. </p>
          <hr className="hr-decor"/>

          <h1 className="font-xxl font-bold text-center">
            CHARGING TERMS AND CONDITIONS
          </h1>
          <p className="font-md font-light text-center">
          Read the Charging Terms and Conditions before using an ORLEN charging stations.
          </p>
          <p className="text-center font-xs font-light mt-4">
            Click to download charging rules in PDF format: <a href={RegulaminFile} target="_blank" rel="noreferrer" className="text-white text-underline font-bold">Individual Customer</a>  / <a href={RegulaminFileFlota} target="_blank" rel="noreferrer" className="text-white text-underline font-bold">ORLEN fleet</a>.
          </p>
          <p className="text-center font-xs font-light mt-2 mb-4">Terms and Conditions are valid from 12 September 2024.</p>
          <hr className="hr-decor"/>
          <p className="text-center font-xs font-light mt-4">Archive Terms ( <a href={RegulaminFileOld} target="_blank" rel="noreferrer" className="text-white text-underline">individual Customer</a> | <a href={RegulaminFileFlotaOld} target="_blank" rel="noreferrer" className="text-white text-underline">ORLEN fleet</a> ) valid till 11 September 2024.</p>
        </div>
      </BackgroundImage>
    </Layout>
  )
}
export default Regulamin



